<template>
  <div>
    <div
      id="app"
      style="
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
      "
    >
      <div>
        <!-- <teleport to="notification-outlet">
          <div style="position: absolute; top: 20px; right: 20px;">
            <slot />
          </div>
        </teleport> -->
        <!-- <teleport to="notification-outlet">
          <notification style="position: absolute; top: 20px; right: 20px;">
            This overlay can be positioned absolutely very easily.
          </notification>
        </teleport> -->
      </div>
      <div class="app-container">
        <Navbar />
        <div class="route-container">
          <router-view v-slot="{ Component, route }">
            <transition name="fade" mode="out-in">
              <component :is="Component" :key="route.name" />
            </transition>
          </router-view>
        </div>
        <Footer />
      </div>
      <notifications position="bottom right"></notifications>
    </div>
    <div id="modals"></div>
    <Cookies />
    <!-- <teleport to="modals"></teleport> -->
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import "./scss/global.scss";
import "./scss/main.scss";
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Cookies from "./components/modal/Cookies.vue";
import { subscribeToChannel, unsubscribeFromChannel } from "./pusher.js";

const user = computed(() => store.state.user);

const store = useStore();
const { locale } = useI18n();
const intervalId = ref(null);
const intervalId2 = ref(null);
let matchChannel = null;

const initLocale = () => {
  if (window.$cookies.get("locale")) {
    locale.value = window.$cookies.get("locale");
  }
};

const initSession = () => {
  store.dispatch("session").catch((e) => {
    console.error(e);
    this.$notify({
      type: "error",
      title: `❌ ${t("Error")}`,
      text: e,
    });
  });
};

initSession();

store.dispatch("getActiveMatches");
initLocale();
store.dispatch("getPrematchCount");

setInterval(() => {
  store.dispatch("getLiveMatches");
}, 10 * 1000);
setInterval(() => {
  store.dispatch("getOddsMatches");
}, 20 * 1000);

intervalId.value = setInterval(
  () => {
    initSession();
  },
  3 * 60 * 1000,
);

intervalId2.value = setInterval(() => {
  store.commit("REMOVE_EXPIRED_MATCHES");
}, 30 * 1000);

const handleMyEvent = (data) => {
  console.log("Отримано з private-base-match (Vue компонент):", data);
  latestMessage.value = data;
};

onMounted(() => {
  store.dispatch("getSocials")
  matchChannel = subscribeToChannel(
    "private-base-match",
    "my-event",
    handleMyEvent,
  );
});

// function subscribe() {
//   if (!pusher) {
//     pusher = new Pusher("app-key", {
//       cluster: "mt1",
//       wsHost: "localhost",
//       wsPort: 6001,
//       wssPort: 6001,
//       forceTLS: false,
//       enabledTransports: ["ws", "wss"],
//     });
//   }

//   if (!channel) {
//     channel = pusher.subscribe("my-channel");
//     channel.bind("my-event", (data) => {
//       alert("Отримано: " + JSON.stringify(data));
//       message.value = JSON.stringify(data);
//     });
//     isSubscribed.value = true;
//   }
// }

// function unsubscribe() {
//   if (channel) {
//     channel.unbind_all();
//     pusher.unsubscribe("my-channel");
//     channel = null;
//     isSubscribed.value = false;
//   }
//   if (pusher) {
//     pusher.disconnect();
//     pusher = null;
//   }
// }

watch(
  () => user.value,
  (val) => {
    if (val) {
      if (val.permision==="isDev") {
        matchChannel = subscribeToChannel(
          "private-base-match",
          "my-event",
          handleMyEvent,
        );
        // subscribe();
      } else {
        unsubscribeFromChannel("private-base-match", "my-event", handleMyEvent);
        console.log("Компонент розмонтовано, відписка від private-base-match.");
        // unsubscribe();
      }
    }
  },
  { immediate: true, deep: true },
);

onUnmounted(() => {
  // unsubscribe();
  unsubscribeFromChannel("private-base-match", "my-event", handleMyEvent);
  console.log("Компонент розмонтовано, відписка від private-base-match.");

  clearInterval(intervalId.value);
  clearInterval(intervalId2.value);
});
</script>

<style lang="scss">
@use "./scss/variables" as *;

:root {
  --brand-color: #{$brandColor};
  --body-color: #{$lightBodyColor};
  --body-color-second: #{$lightBodyColorSecond};
  --body-color-third: #{$lightBodyColorThird};
  --footer-color: #{$lightFooterColor};
  --footer-color-light: #{$lightFontColor};
  --footer-color-dark: #{$darkFontColor};
  --font-color: #{$lightFontColor};
  --font-color-hover: #{$lightFontColorHover};
  --match-card-color: #{$lightMatchCardColor};
  --match-card-header-color: #{$lightMatchCardHeaderColor};
  --tab-color: #{$lightTabColor};
  --tab-hover-color: #{$lightTabHoverColor};
  --select-color: #{$lightSelectColor};
  --select-hover-color: #{$lightHoverSelectColor};
  --success-color: #{$successColor};
  --warning-color: #{$warningColor};
  --danger-color: #{$dangerColor};
  --success-background: #{$successBackground};
  --warning-background: #{$warningBackground};
  --danger-background: #{$dangerBackground};
  --success-background-dark: #{$successBackgroundDark};
  --warning-background-dark: #{$warningBackgroundDark};
  --danger-background-dark: #{$dangerBackgroundDark};
  --success-background-opacity-low: #{$successBackgroundOpacityLow};
  --warning-background-opacity-low: #{$warningBackgroundOpacityLow};
  --danger-background-opacity-low: #{$dangerBackgroundOpacityLow};
  --success-background-opacity-medium: #{$successBackgroundOpacityMedium};
  --warning-background-opacity-medium: #{$warningBackgroundOpacityMedium};
  --danger-background-opacity-medium: #{$dangerBackgroundOpacityMedium};
  --league-body-color: #{$lightLeagueBodyColor};
  --match-border-color: #{$lightMainBorderColor};
  --shots-body-color: #{$lightShotsBodyColor};
  --arrow-color: #{$lightArrowBorderColor};
  --live-gate-body-color: #{$lightGateBodyColor};
  --back-color: #{$lightMobileFontColor};
}

:root.dark-theme {
  --body-color: #{$darkBodyColor};
  --body-color-second: #{$darkBodyColorSecond};
  --body-color-third: #{$darkBodyColorThird};
  --footer-color: #{$darkFooterColor};
  --font-color: #{$darkFontColor};
  --match-card-color: #{$darkMatchCardColor};
  --match-card-header-color: #{$darkMatchCardHeaderColor};
  --tab-color: #{$darkTabColor};
  --tab-hover-color: #{$darkTabHoverColor};
  --select-color: #{$darkSelectColor};
  --select-hover-color: #{$darkHoverSelectColor};
  --league-body-color: #{$darkLeagueBodyColor};
  --match-border-color: #{$darkMainBorderColor};
  --shots-body-color: #{$darkShotsBodyColor};
  --arrow-color: #{$darkArrowBorderColor};
  --live-gate-body-color: #{$darkGateBodyColor};
  --back-color: #{$darkMobileFontColor};
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background-color: var(--body-color);
  color: var(--font-color);
  font-family: "DINPro", sans-serif;
}

#app {
  .app-container {
    width: 100%;
    padding: 15px;
    max-width: 1200px;
    height: 100%;
    min-height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
  }

  .route-container {
    position: relative;
    margin: 48px;
    min-height: calc(100vh - 23.5rem);
    overflow: hidden;
    display: block;
    flex-grow: 6;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    order: 0;
    min-height: 60vh;

    @media (max-width: $tablet) {
      margin: 0;
    }
  }
}

.has-text-success {
  color: var(--success-background);
}

.has-background-success {
  background-color: var(--success-background);
}

.is-success:not(input) {
  background-color: var(--success-color);
}

.has-text-warning {
  color: var(--warning-background);
}

.has-background-warning {
  background-color: var(--warning-background);
}

.is-warning {
  background-color: var(--warning-color);
}

.has-text-danger {
  color: var(--danger-background);
}

.has-background-danger {
  background-color: var(--danger-background);
}

.is-danger {
  background-color: var(--danger-color);
}

.has-background-warning,
.has-background-success,
.has-background-danger {
  color: #121212;
  fill: #121212;
  stroke: #121212;
}

.match-list-container {
  .match-list-controls {
    margin-bottom: 1rem;

    .match-list {
      padding-bottom: 1rem;
    }
  }

  .section {
    &.mini {
      padding: 0.5rem;
    }
  }

  .is-clickable {
    cursor: pointer !important;
  }

  .soon,
  .beta,
  .counter {
    border-radius: 10%;
    line-height: 1rem;
    text-transform: uppercase;
    vertical-align: top;
    font-size: 0.65em;
    text-align: center;
    color: var(--font-color);
    background-color: var(--success-background);
  }

  .soon,
  .beta {
    padding: 0rem 0.2rem;
  }

  .soon {
    &:before {
      content: "soon";
    }
  }

  .beta {
    &:before {
      content: "beta";
    }
  }

  .counter {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    font-weight: bold;
  }

  .modal {
    z-index: 140;
  }

  .buttons {
    .modal-button {
      .button {
        margin-right: 0.5rem;
      }
    }
  }

  .field {
    &.has-addons {
      .control {
        button {
          margin: 0;
        }
      }
    }

    .control {
      &.has-icons-left,
      &.has-icons-right {
        .icon {
          color: var(--font-color);
        }
      }
    }
  }

  .input,
  .textarea,
  .select select {
    background-color: var(--footer-color);
    color: var(--font-color);
    box-shadow: none;
    border-radius: unset;

    &::placeholder {
      color: var(--font-color);
    }
  }

  .select {
    &.is-small {
      height: 2em;

      select {
        line-height: 1em;
        height: 2em;
      }
    }

    &:not(.is-multiple):not(.is-loading)::after {
      border-color: var(--font-color);
      right: 0.625em;
    }
  }

  //LOADER STYLES
  .loader-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    z-index: -1;
    transition: opacity 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;

    .loader {
      height: 80px;
      width: 80px;
    }

    &.is-active {
      opacity: 1;
      z-index: 1;
    }
  }

  .is-size-8 {
    font-size: 0.55rem !important;
  }

  .is-huge {
    height: 45px;
    max-height: 45px;
    max-width: 45px;
    min-height: 45px;
    min-width: 45px;
    width: 45px;
  }
}
</style>
